export const DEFAULT_COL_WIDTH = 150;
export const MIN_COL_WIDTH = 60;
